import * as React from 'react';
import { Feature } from '@tencent/workbench';
import BaseColorFeature from '@framework/workbench/common/feature/base-color-feature';
import { config } from './config';
import {
    ColorPickerActionType,
    ColorPickerType,
} from '@src/js/common/ark-extensions/dc-components/color-picker/type';
import i18n from '@i18next/i18n';
import { NO_COLOR } from '@src/slide/infrastructure/module/independent/color/constant';
import {
    TDWVer5Type,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { MenuType } from '@src/slide/domain/ui-model/constant/menu';
import { ITDColor, TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

@Feature()
export class BackColorFeature extends BaseColorFeature {
    id = config.id;
    config = config;
    public getBackColorDropDownContent = menuType => this.getColorPickerDropDownContent({
        onColorChange: (tdColor, source) => {
            this.handleFontColorChange(tdColor);
            // 上报数据
            this.getColorPickerManager()?.colorPickerTdwReport({
                color: tdColor.srgb_color || '',
                colorPickerFrom: menuType,
                colorGroupFrom: source,
                actionType: TDWVer5Type.COLOR_PICKER_BACK_FONT,
            });
        },
        colorPickerType: ColorPickerType.StandardPC,
        actions: [{
            text: i18n.t('无颜色'),
            position: ColorPickerActionType.Top,
            onClick: this.handleNoColor,
        }],
        isStandardColorPicker: true,
    });

    public handleFontColorChange = (tdColor: ITDColor) => {
        this.getMenuManager()?.toolbarMenu()
            .callback(MenuType.TOOLBAR, this.id, tdColor, tdColor);
        this.saveRecentColorWithId(tdColor);
    };

    private handleNoColor = () => {
        const color = null;
        this.saveRecentColorWithId(null);
        this.getAppService().editableServiceLayer?.colorPickerManager.handleFontColorChange({
            color,
            option: color,
            id: this.id,
        });
    };
}
